import { useMediaQuery } from "usehooks-ts";

// px değerini key'den çıkart (base = 0)
const parseBreakpoint = (key: string) => {
  if (key === "base") return 0;
  return Number(key.replace("w", ""));
};

export function useProductSupplierResponsesTemplate() {
  // 1. Tüm template'leri { width, template } formatına çevir
  const entries = Object.entries(TEMPLATES).map(([key, template]) => ({
    key,
    width: parseBreakpoint(key),
    template,
  }));

  // 2. breakpoints küçükten büyüğe sırala
  const sorted = entries.sort((a, b) => a.width - b.width);

  // 3. Her breakpoint için media query oluştur
  const matches = sorted.map((entry) =>
    useMediaQuery(`(min-width: ${entry.width}px)`)
  );

  // 4. En büyük TRUE breakpoint'i seç
  let active = sorted[0]; // base
  for (let i = 0; i < sorted.length; i++) {
    if (matches[i]) active = sorted[i];
  }

  return active.template;
}

export const TEMPLATES = {
  base: [
    "minmax(200px,1fr)", // User (Tedarikçiler)
    "137px", // Progress (Tamamlanan)
    "144px", // Count (Yorum)
    "63px", // Time 1 (Süre)
    "119px", // Time 2 (Son Hareket)
    "90px", // Status (Durum)
    "62px", // Actions
  ],

  w1250: [
    "minmax(250px,1fr)",
    "200px",
    "150px",
    "80px",
    "130px",
    "100px",
    "62px",
  ],

  w1400: [
    "minmax(300px,1fr)",
    "200px",
    "170px",
    "90px",
    "150px",
    "150px",
    "62px",
  ],

  w1500: [
    "minmax(300px,1fr)",
    "250px",
    "170px",
    "90px",
    "150px",
    "150px",
    "62px",
  ],

  w1570: [
    "minmax(300px,1fr)",
    "300px",
    "170px",
    "90px",
    "150px",
    "150px",
    "62px",
  ],

  w1650: [
    "minmax(300px,1fr)",
    "300px",
    "220px",
    "120px",
    "180px",
    "180px",
    "62px",
  ],

  w1760: [
    "minmax(300px,1fr)",
    "300px",
    "260px",
    "140px",
    "200px",
    "200px",
    "62px",
  ],

  w1860: [
    "minmax(350px,1fr)",
    "330px",
    "270px",
    "150px",
    "150px",
    "220px",
    "62px",
  ],
};
